import React from 'react';
import Link from 'next/link';

const FacebookIcon = () =>
<img alt="" src="https://printhubsolution.com/_next/static/media/facebook.06da626e.svg" className="h-auto w-4 shrink-0" width={36} height={36} />;

const YoutubeIcon = () =>
<img alt="" src="https://printhubsolution.com/_next/static/media/youtube.9ed9bf57.svg" className="h-auto w-4 shrink-0" width={36} height={36} />;

const TelegramIcon = () =>
<img alt="" src="https://printhubsolution.com/_next/static/media/telegram.e9cee8d8.svg" className="h-auto w-4 shrink-0" width={36} height={36} />;

const TwitterIcon = () =>
<img alt="" src="https://printhubsolution.com/_next/static/media/twitter.6850a451.svg" className="h-auto w-4 shrink-0" width={21} height={18} />;


const GiftIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5 text-violet-100">
    <path strokeLinecap="round" strokeLinejoin="round" d="M21 11.25v8.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 1 0 9.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1 1 14.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z" />
  </svg>;


const RefreshIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5 text-violet-100">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 0 0-3.7-3.7 48.678 48.678 0 0 0-7.324 0 4.006 4.006 0 0 0-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 0 0 3.7 3.7 48.656 48.656 0 0 0 7.324 0 4.006 4.006 0 0 0 3.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3-3 3" />
  </svg>;


const CardIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5 text-violet-100">
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
  </svg>;


const TruckIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5 text-violet-100">
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
  </svg>;


const ShieldCheckIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-8 w-8">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
  </svg>;


const ArrowRightIcon = () =>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-4 w-4">
    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
  </svg>;


const footerBenefits = [
{ icon: <GiftIcon />, title: 'Model-Matched Guidance', subtitle: 'Choose by real printer workload' },
{ icon: <RefreshIcon />, title: 'Clear Condition Notes', subtitle: 'Know the refurb grade upfront' },
{ icon: <CardIcon />, title: 'Verified Product Details', subtitle: 'Specs organized before checkout' },
{ icon: <TruckIcon />, title: 'Helpful Buyer Support', subtitle: 'Questions answered before you buy' }];


const shopLinks = [
{ label: 'Inkjet Printers', href: '/inkjet-printers' },
{ label: 'Home Printers', href: '/home-printers' },
{ label: 'Office Printers', href: '/office-printers' },
{ label: 'Cart', href: '/cart' }];


const guideLinks = [
{ label: 'Buying Guides', href: '/guides' },
{ label: 'Home Printer Guide', href: '/guides' },
{ label: 'Office Printer Guide', href: '/guides' },
{ label: 'Inkjet Printer Tips', href: '/guides' }];


const companyLinks = [
{ label: 'Home', href: '/' },
{ label: 'Guides', href: '/guides' },
{ label: 'About', href: '/about' },
{ label: 'Contact', href: '/contact' }];


const legalLinks = [
{ label: 'Refund and Return', href: '/refund-and-return' },
{ label: 'Shipping Policy', href: '/shipping-policy' },
{ label: 'Purchase Policy', href: '/purchase-policy' },
{ label: 'Privacy Policy', href: '/privacy-policy' },
{ label: 'Terms & Conditions', href: '/terms-and-conditions' }];


const bottomLinks = [
{ label: 'Disclaimer', href: '/disclaimer' },
{ label: 'Privacy Policy', href: '/privacy-policy' },
{ label: 'Terms & Conditions', href: '/terms-and-conditions' },
{ label: 'Accessibility', href: '/accessibility' },
{ label: 'Sitemap', href: '/site-map' },
{ label: 'XML Sitemap', href: '/sitemap.xml' }];


export default function Footer() {
  return (
    <footer className="w-full bg-[linear-gradient(180deg,#07111f_0%,#030812_100%)] text-white">
      <div className="w-full overflow-hidden border-t border-slate-800 bg-[linear-gradient(180deg,#07111f_0%,#030812_100%)] shadow-[0_22px_70px_rgba(2,6,23,0.28)]">
        {/* Benefits bar */}
        <div className="grid bg-[linear-gradient(90deg,#6d1bb6_0%,#0f2f78_55%,#063b75_100%)] sm:grid-cols-2 lg:grid-cols-4">
          {footerBenefits?.map((benefit, i) =>
          <div
            key={i}
            className={`flex items-center gap-4 px-6 py-5 ${
            i > 0 ? 'border-t border-white/12 sm:border-t-0 sm:border-l' : ''}`
            }>
            
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/25 bg-white/8">
                {benefit?.icon}
              </span>
              <span>
                <span className="block text-sm font-semibold text-white">{benefit?.title}</span>
                <span className="mt-1 block text-xs text-blue-100/78">{benefit?.subtitle}</span>
              </span>
            </div>
          )}
        </div>

        {/* Main footer content */}
        <div className="container py-8">
          <div className="grid gap-9 lg:grid-cols-[1.12fr_1.88fr]">
            {/* Brand column */}
            <div>
              <div className="inline-flex rounded-[8px] bg-white p-2.5">
                <Link href="/" className="flex items-center shrink-0" aria-label="RePrint Solution home">
                  <img
                    alt="RePrint Solution"
                    src="https://img.rocket.new/generatedImages/rocket_gen_img_1d5ccfb58-1768521386698.png"
                    width={236}
                    height={80}
                    className="h-12 w-auto" />
                  
                </Link>
              </div>
              <p className="mt-3 text-xs font-semibold text-slate-300">Premium Refurbished Printers &amp; Value</p>
              <p className="mt-5 max-w-md text-sm leading-6 text-slate-300">
                RePrint Solution helps homes and offices choose professionally checked refurbished inkjet printers with clear model details, buying guidance, and delivery help.
              </p>
              <div className="mt-5">
                <div className="flex flex-row items-center gap-2 text-slate-300">
                  {[
                  { label: 'Facebook', icon: <FacebookIcon /> },
                  { label: 'Youtube', icon: <YoutubeIcon /> },
                  { label: 'Telegram', icon: <TelegramIcon /> },
                  { label: 'Twitter', icon: <TwitterIcon /> }]?.
                  map((social) =>
                  <a
                    key={social?.label}
                    href="#"
                    target="_blank"
                    aria-label={social?.label}
                    className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/5 transition hover:border-cyan-300/40 hover:bg-white/10">
                    
                      {social?.icon}
                    </a>
                  )}
                </div>
              </div>
            </div>

            {/* Links columns */}
            <div className="grid grid-cols-2 gap-7 sm:grid-cols-4">
              {[
              { title: 'Shop', links: shopLinks },
              { title: 'Guides', links: guideLinks },
              { title: 'Company', links: companyLinks },
              { title: 'Legal', links: legalLinks }]?.
              map((col) =>
              <div key={col?.title} className="text-sm">
                  <h2 className="text-xs font-black tracking-[0.16em] text-violet-300 uppercase">{col?.title}</h2>
                  <ul className="mt-4 space-y-2.5">
                    {col?.links?.map((link) =>
                  <li key={link?.label}>
                        <Link href={link?.href} className="text-sm text-slate-300 transition hover:text-white">
                          {link?.label}
                        </Link>
                      </li>
                  )}
                  </ul>
                </div>
              )}
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-8 flex items-start gap-3 rounded-[10px] border border-white/10 bg-white/[0.035] p-5">
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-[8px] bg-violet-600 text-white">
              <ShieldCheckIcon />
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-x-3 gap-y-2 text-sm text-slate-400">
                {bottomLinks?.map((link, i) =>
                <React.Fragment key={link?.href}>
                    <Link href={link?.href} className="transition hover:text-white">{link?.label}</Link>
                    {i < bottomLinks?.length - 1 && <span className="text-slate-700">|</span>}
                  </React.Fragment>
                )}
              </div>
              <p className="mt-4 max-w-4xl text-xs leading-6 text-slate-400">
                RePrint Solution is an independent refurbished printer retailer and is not affiliated with, sponsored by, or endorsed by any printer manufacturer or brand. All brand names, product names, logos, and trademarks are the property of their respective owners.
              </p>
            </div>
            <div className="hidden border-l border-white/10 pl-8 text-right text-xs leading-6 text-slate-400 lg:block">
              <p>© 2026 RePrint Solution.</p>
            </div>
          </div>
          <div className="mt-5 text-xs leading-6 text-slate-400 lg:hidden">
            <p>© 2026 RePrint Solution.</p>
          </div>
        </div>
      </div>
    </footer>);


}